export var Scope;
(function (Scope) {
    Scope["APP"] = "APP";
    Scope["COMPONENT"] = "COMPONENT";
})(Scope || (Scope = {}));
//# sourceMappingURL=domain.js.map